import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {EventUserInfo} from './../models/user-info';
import {IEventRegistrationRepository} from './../repositories/event-registration.repository.interface';

@Injectable()
export class EventRegistrationService {

  constructor(@Inject('IEventRegistrationRepository') private eventRegistrationRepository: IEventRegistrationRepository) { }

  public register(data: EventUserInfo): Observable<string> {
    return this.eventRegistrationRepository.register(data);
  }

}
